import React from 'react';
import ReactDOM from 'react-dom';
import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import resources from '../../resources';
import { SignerService } from '../identity/dependents/service/SignerService'


let CryptoJS = require("crypto-js");


export const loadWidgetByConfig = (function () {
	let instance;
	let data = {};
  
	function initialize(configData) {
	  document.cookie = "IRIS_APPID=" + configData.id + "; path=/; samesite=strict; secure;domain=" + window.location.hostname;
	  data = configData;
	  const siteName = configData.name;
	  const domain = configData.domain;
	  const widgetConfig = configData.widget_configs.find((obj) => obj.type === 'identity');
	  const pages = widgetConfig.pages;
	  const properties = widgetConfig.properties;
	  const skin = properties.style;
	  const redirect_signin_url = process.env.REACT_APP_REDIRECT_SIGNIN;
	  const redirect_signout_url = process.env.REACT_APP_REDIRECT_SIGNOUT;
	  const clientId = configData.client_id || process.env.REACT_APP_PASSPORT_SOCIAL_LOGIN_APP_CLIENT_ID;
	  const brand = properties.brand;
	  const division = properties.division;
	  const linkedin_redirect_url = process.env.LINKEDIN_REDIRECT_URL;
	  const IS_LOCALHOST = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.indexOf('.local') >= 0;
  
	  const props = {
		identityConfig: {
		  id: configData.id ? configData.id : appId,
		  siteName,
		  language,
		  showShareIcons: "",
		  configureRoles: false,
		  siteType: configData.type ? configData.type : '',
		  siteSubType: configData.sub_type ? configData.sub_type : '',
		  newsLetterName: properties.newsletter_name || '',
		  publicAssetsUrl: properties.public_assets_url,
		  skin,
		  apiBaseURL,
		  clientId,
		  redirect_signin_url,
		  redirect_signout_url,
		  brand,
		  division,
		  check_user: '',
		  crud_user: '',
		  integration_type: 'javascript',
		  hide_social: properties.hide_social || [],
		  domain: IS_LOCALHOST ? document.location.hostname : domain,
		  captcha: !window.location.host.includes('localhost') && properties.captcha ? properties.captcha : false,
		  captcha_type: properties.captcha_type || 'hcaptcha',
		  email_case_insensitive: true,
		  welcome_email_template: configData.configId || "iiris",
		  linkedin_redirect_url,
		  pages,
		  is_modal: isModal,
		  registrationType: configData.registrationType,
		  show_progressive_profile: showProgressiveProfile,
		  show_registration: showRegistration,
		  show_social_login_names: showSocialLoginNames,
		  default_social_option: defaultOption || '',
		  passwordless_login: passwordLessLogin,
		  cognito_add_business_email_attr: cognitoAddBusinessEmail,
		  email_login_option: properties.email_login_option || "all",
		  persist_session: properties.hasOwnProperty('persist_session') ? properties.persist_session : true,
		  environment_mode: configData?.mode === 'draft' ? 'dev': configData?.mode === 'final' ? 'prod' : process.env.ENV_MODE,
		  locale: configData?.locale[0]
		}
	  };
  
	  // Initialize i18n
	  i18n
		.use(initReactI18next)
		.init({
		  resources,
		  lng: language,
		  fallbackLng: "en",
		});
	  return props;
	}
  
	return {
	  setConfigData: function (configData) {
		if (!instance) {
		  instance = initialize(configData);
		}
	  },
	  getConfigData () {
		return data;
	  },
	  getInstanceProps(){
		return instance;
	  }
	};
  })();


const identityWidget = document.getElementById('iiris-identity');
const isModal = !(identityWidget.getAttribute('ismodal') === "false");
const showProgressiveProfile = !(identityWidget.getAttribute('showprogressiveprofile') === "false");
const showRegistration = !(identityWidget.getAttribute('showregistration') === "false");
const showSocialLoginNames = !(identityWidget.getAttribute('showSocialLoginNames') === "false");
const defaultOption = identityWidget.getAttribute('defaultOption');
const passwordLessLogin = identityWidget.getAttribute('logintype') !== "password";
const cognitoAddBusinessEmail = identityWidget.getAttribute('cognitoAddBusinessEmail') && identityWidget.getAttribute('cognitoAddBusinessEmail') === "true";
const language = identityWidget.getAttribute("locale") || "en";
const apiBaseURL = process.env.API_BASE_URL;

// Setting up the  cookie for locale.
document.cookie = "IDENTITY_LOCALE=" + language + "; path=/; samesite=strict; secure;domain=" + window.location.hostname;
// const isAutomated = identityWidget.getAttribute('isAutomated');


export const loadAndDecryptConfigData = async () => {
	try {
		const configId = identityWidget.getAttribute("configId");
		if (configId) {
			const dynamoConfigData = await SignerService({
				method: "GET",
				url: apiBaseURL + "/v1/admin/public/config/item/" + configId,
			});
			if(dynamoConfigData.statusCode === 404){
				throw new Error("Configuration not found for the provided configId.");
			}
			loadWidgetByConfig.setConfigData({...dynamoConfigData.config, configId: dynamoConfigData.object_key, mode: dynamoConfigData.mode});
			window.IIRISProfileMgr.getIIRISProfile(dynamoConfigData.config);
		}
	} catch (e) {
		console.error("Error fetching or processing config data: ", e);
	}
}